export default class EventUpsertModel {
  public eventCategoryId = "";
  public calendarId = "";
  public title = "";
  public startDate = new Date();
  public endDate = new Date();
  public eventUserIds = new Array<string>();

  constructor(data?: any) {
    if (!data) {
      return;
    }

    Object.assign(this, data);
  }
}
